export const CHANGE_TRANSACTION_ACTIVE_TAB = 'CHANGE_TRANSACTION_ACTIVE_TAB';
export const CHANGE_LOG_TRANSACTION_DATA = 'CHANGE_LOG_TRANSACTION_DATA';
export const CHANGE_TRANSACTION_POINT_SELECTION = 'CHANGE_TRANSACTION_POINT_SELECTION';
export const CHANGE_TRANSACTION_BILL_STAGE_SELECTION = 'CHANGE_TRANSACTION_BILL_STAGE_SELECTION';